import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from '@app/service/header/header.service';
import { UserService } from '@app/service/user-service/user.service';
import { ResolveType, StateService } from 'src/app/service/state/state.service';
import { RouteComponent } from '../../route.component';
import { PaymentRequestStatus } from '@app/model/payment-request/payment-request.dto';

@Component({
  selector: 'app-de-error',
  templateUrl: './de-error.component.html',
  styleUrls: ['../../page-shared.css', './de-error.component.scss'],
})
export class DeErrorComponent extends RouteComponent implements OnInit {
  navigationInProgress = false;
  invalidPRStateForProceeding: boolean;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected headerService: HeaderService,
    protected stateService: StateService,
    private userService: UserService
  ) {
    super(router, route, stateService, headerService);
  }

  ngOnInit(): void {
    if (
      this.state.status === PaymentRequestStatus.CANCELLED ||
      this.state.status === PaymentRequestStatus.EXPIRED
    ) {
      this.invalidPRStateForProceeding = true;
    }
  }

  async handleCtaClick(): Promise<void> {
    this.navigationInProgress = true;
    try {
      if (this.state.interruptionDetails.cancelUrlOverridesCta) {
        const resp = await this.userService.cancelPayment();
        if (resp.success) {
          window.location.href = this.state.merchantUrls?.onCancelUrl;
        }
      } else {
        await this.resolveInterruption(ResolveType.CTA);
      }
    } catch (error) {
      console.log(error);
    }
    this.navigationInProgress = false;
  }

  async handleLinkClick(): Promise<void> {
    this.navigationInProgress = true;
    try {
      if (this.state.interruptionDetails.cancelUrlOverridesLink) {
        const resp = await this.userService.cancelPayment();
        if (resp.success) {
          window.location.href = this.state.merchantUrls?.onCancelUrl;
        }
      } else if (this.state.interruptionDetails.linkExternalDestination) {
        window.open(
          this.state.interruptionDetails.linkExternalDestination,
          '_blank'
        );
      } else {
        await this.resolveInterruption(ResolveType.LINK);
      }
    } catch (error) {
      console.log(error);
    }
    this.navigationInProgress = false;
  }
}
